//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContactSalesForm from '@/components/forms/ContactSalesForm.vue';
export default {
  components: { ContactSalesForm },
  head: {
    title: 'Contact Sales | BOMIST',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          'Talk to the BOMIST sales team. Get a demo, discuss your team needs, or ask about enterprise pricing.'
      }
    ]
  }
};
